import React from 'react'

function Footer({ handleNextClick, handlePrevClick, prevHidden, nextHidden = false, nextDisabled = false, nextDisabledClick = null }) {

  return (
    <div className="footer">
      <div className="navbar">
        <div onClick={handlePrevClick} className={`prev ${prevHidden ? 'hidden' : ''}`}><img src={require(`../assets/images/btn-prev-2.png`)} alt="Back" /></div>
        <div onClick={nextDisabled ? nextDisabledClick : handleNextClick} className={`next ${nextHidden ? 'hidden' : ''}`}><img src={nextDisabled ? require(`../assets/images/btn-next-2.png`) : require(`../assets/images/btn-next-2-active.png`)} alt='Next' /></div>
      </div>
    </div>
  )
}
export default Footer

export function FooterWithPrice({ handleNextClick, handlePrevClick, prevHidden, nextHidden, totalPrice, totalPriceLabel, nextDisabled }) {
  return (
    <div className="footer">
      <div className="navbar">
        <div onClick={handlePrevClick} className={`prev ${prevHidden ? 'hidden' : ''}`}><img src={require(`../assets/images/btn-prev-2.png`)} alt="Back" /></div>
        <div className="text-center"><b className='footer__total'>{totalPriceLabel}</b> € {totalPrice || 0}</div>
        <div onClick={nextDisabled ? null : handleNextClick} className={`next ${nextHidden ? 'hidden' : ''}`}><img src={nextDisabled ? require(`../assets/images/btn-next-2.png`) : require(`../assets/images/btn-next-2-active.png`)} alt='Next' /></div>
      </div>
    </div>
  )
}

export function FooterWithClose({ handleCloseClick, isHidden }) {
  return !isHidden ? (
    <div className="footer">
      <div className="navbar justify-content-center">
        <div onClick={handleCloseClick} className="btn-close"><img src={require("../assets/images/btn-close-orange.png")} alt="" width="40px" /></div>
      </div>
    </div>
  ) : null
}
